import React, { JSX, useEffect, useState } from 'react';
import Icons from 'components/atoms/Icons';
import { useRouter } from 'next/router';

type ProfileBreadcrumbProps = {
  searchType: string;
  name?: string;
};

const ProfileBreadcrumb = (props: ProfileBreadcrumbProps): JSX.Element => {
  const { searchType, name } = props;
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState('');
  const handleBack = () => {
    router.push(`/${searchType}${searchQuery}`);
  };

  const searchLabel =
    searchType === 'providers' ? 'Find a Provider' : 'Find a Location';

  const normalizedName = name?.trim() || '';

  const hasValidName =
    normalizedName.length > 0 &&
    !normalizedName.toLowerCase().includes('undefined') &&
    !normalizedName.toLowerCase().includes('null');

  useEffect(() => {
    if (
      router.asPath.includes('/locations') &&
      localStorage.getItem('locationSearch') !== null
    ) {
      setSearchQuery(
        decodeURIComponent(localStorage.getItem('locationSearch') as string)
      );
    } else if (
      router.asPath.includes('/providers') &&
      localStorage.getItem('providerSearch') !== null
    ) {
      setSearchQuery(
        (localStorage.getItem('providerSearch') as string).includes(
          'specscombo'
        )
          ? decodeURIComponent(
              localStorage.getItem('providerSearch') as string
            ).replace('specscombo', 'specialtyfilters')
          : decodeURIComponent(localStorage.getItem('providerSearch') as string)
      );
    }
  }, []);

  return (
    <div className="overhauled profile-breadcrumb">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <div className="breadcrumb-inner">
          <ul>
            <button
              className="back-link"
              onClick={() => (searchQuery ? handleBack() : router.back())}
            >
              <span className="icon-btn">
                <Icons
                  className="icon icon-arrow-go"
                  id="arrow-go"
                  aria-hidden="true"
                />
              </span>
              <span className="search-text osf-link">
                Back to search results
              </span>
            </button>
            <li>
              <a className="track-nav" href={`/${searchType}`}>
                {searchLabel}

                {hasValidName && <Icons id="chevron-next" />}
              </a>
            </li>

            {hasValidName && <li aria-current="page">{normalizedName}</li>}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default ProfileBreadcrumb;
